import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function extractYouTubeId(url?: string | null): string | null {
  if (!url) {
    return null;
  }

  try {
    const parsed = new URL(url);
    if (parsed.hostname === 'youtu.be') {
      return parsed.pathname.slice(1) || null;
    }
    if (parsed.searchParams.has('v')) {
      return parsed.searchParams.get('v');
    }

    const pathMatch = parsed.pathname.match(/\/(?:embed|v|shorts)\/([^/?]+)/);
    if (pathMatch && pathMatch[1]) {
      return pathMatch[1];
    }
  } catch (error) {
    // Fallback to regex parsing for non-standard urls
    const idMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([\w-]{11})/);
    if (idMatch && idMatch[1]) {
      return idMatch[1];
    }
  }

  return null;
}

export function getYouTubeThumbnail(
  youtubeId: string,
  quality: 'default' | 'mqdefault' | 'hqdefault' | 'sddefault' | 'maxresdefault' = 'hqdefault',
) {
  return `https://img.youtube.com/vi/${youtubeId}/${quality}.jpg`;
}